"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@folio/stripes/components");
var _hooks = require("../../hooks");
var _customProperties = require("../../constants/customProperties");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// A default option for CustProp view pane, with the ability to override labels for fields
const CustomPropertyView = _ref => {
  let {
    customProperty,
    helpPopovers,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {}
  } = _ref;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.label',
              overrideValue: labelOverrides?.label
            }), helpPopovers?.label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.label
            }) : null]
          }),
          value: customProperty?.label
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.name',
              overrideValue: labelOverrides?.name
            }), helpPopovers?.name ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.name
            }) : null]
          }),
          value: customProperty?.name
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Row, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 12,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: kintIntl.formatKintMessage({
            id: 'customProperties.description',
            overrideValue: labelOverrides?.description
          }),
          value: customProperty?.description
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: kintIntl.formatKintMessage({
            id: 'customProperties.primary',
            overrideValue: labelOverrides?.primary
          }),
          value: kintIntl.formatKintMessage({
            id: customProperty?.primary ? 'yes' : 'no',
            overrideValue: customProperty?.primary ? labelOverrides.yes : labelOverrides.no
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: kintIntl.formatKintMessage({
            id: 'customProperties.retired',
            overrideValue: labelOverrides?.retired
          }),
          value: kintIntl.formatKintMessage({
            id: customProperty?.retired ? 'yes' : 'no',
            overrideValue: customProperty?.retired ? labelOverrides.yes : labelOverrides.no
          })
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: kintIntl.formatKintMessage({
            id: 'customProperties.weight',
            overrideValue: labelOverrides?.weight
          }),
          value: customProperty?.weight
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: kintIntl.formatKintMessage({
            id: 'customProperties.defaultVisibility',
            overrideValue: labelOverrides?.defaultVisibility
          }),
          value: kintIntl.formatKintMessage({
            id: customProperty?.defaultInternal ? 'customProperties.internalTrue' : 'customProperties.internalFalse',
            overrideValue: customProperty?.defaultInternal ? labelOverrides.internalTrue : labelOverrides.internalFalse
          })
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Row, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [kintIntl.formatKintMessage({
              id: 'customProperties.ctx',
              overrideValue: labelOverrides?.ctx
            }), helpPopovers?.ctx ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
              content: helpPopovers?.ctx
            }) : null]
          }),
          value: customProperty?.ctx ?? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.NoValue, {})
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: customProperty?.type && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: kintIntl.formatKintMessage({
            id: 'customProperties.type',
            overrideValue: labelOverrides?.type
          }),
          value: kintIntl.formatKintMessage({
            id: `customProperties.type.${customProperty?.type}`,
            overrideValue: labelOverrides?.[customProperty?.type]
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: (customProperty?.type === _customProperties.REFDATA_CLASS_NAME || customProperty?.type === _customProperties.MULTI_REFDATA_CLASS_NAME) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
          label: kintIntl.formatKintMessage({
            id: 'customProperties.category',
            overrideValue: labelOverrides?.category
          }),
          value: customProperty?.category?.desc ?? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.NoValue, {})
        })
      })]
    })]
  });
};
CustomPropertyView.propTypes = {
  customProperty: _propTypes.default.shape({
    id: _propTypes.default.string,
    label: _propTypes.default.string,
    name: _propTypes.default.string,
    description: _propTypes.default.string,
    weight: _propTypes.default.number,
    primary: _propTypes.default.bool,
    retired: _propTypes.default.bool,
    defaultInternal: _propTypes.default.bool,
    ctx: _propTypes.default.string,
    type: _propTypes.default.string,
    category: _propTypes.default.shape({
      desc: _propTypes.default.string
    })
  }),
  helpPopovers: _propTypes.default.object,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object
};
var _default = exports.default = CustomPropertyView;